import React from "react";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Undo2 } from "lucide-react";

/**
 * RollbackModal — Retroceso de una provisión a la fase anterior.
 *
 * Extraído 1:1 desde `pages/ProvisionsPage.js`. Exige un motivo de retroceso que quedará
 * visible en la fase anterior; el checklist se conserva.
 *
 * @param {boolean}  props.rollbackModalOpen     Apertura del diálogo.
 * @param {Function} props.setRollbackModalOpen   Setter del flag de apertura.
 * @param {string}   props.rollbackReason         Motivo del retroceso.
 * @param {Function} props.setRollbackReason      Setter del motivo.
 * @param {Function} props.handleRollback         Confirma el retroceso de fase.
 */
export const RollbackModal = ({
  rollbackModalOpen,
  setRollbackModalOpen,
  rollbackReason,
  setRollbackReason,
  handleRollback,
}) => {
  return (
      <Dialog open={rollbackModalOpen} onOpenChange={setRollbackModalOpen}>
        <DialogContent className="bg-[#0A0A35] border-[#1E1E5F] text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="text-white font-heading flex items-center gap-2">
              <Undo2 className="h-5 w-5 text-orange-400" />
              Devolver a Fase Anterior
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 mt-4">
            <div className="p-3 rounded-lg bg-orange-500/10 border border-orange-500/30">
              <p className="text-orange-400 text-sm">
                Esta acción retrocederá la provisión a la fase anterior. El checklist se mantendrá y el motivo del retroceso será visible en la fase anterior.
              </p>
            </div>
            <div>
              <Label className="text-slate-300">Motivo del retroceso *</Label>
              <Textarea
                value={rollbackReason}
                onChange={(e) => setRollbackReason(e.target.value)}
                placeholder="Explica por qué se debe devolver a la fase anterior..."
                className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white h-24"
              />
            </div>
          </div>
          <div className="flex justify-end gap-3 mt-6">
            <Button
              variant="outline"
              onClick={() => {
                setRollbackModalOpen(false);
                setRollbackReason("");
              }}
              className="border-[#1E1E5F] text-slate-300"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleRollback}
              className="bg-orange-500 text-white hover:bg-orange-600"
            >
              <Undo2 className="h-4 w-4 mr-2" />
              Confirmar Retroceso
            </Button>
          </div>
        </DialogContent>
      </Dialog>
  );
};
